import React from 'react';
import {resolveColor} from '../../../utils/colors';


const AffiliateSearch = ({width = '14px', height = '14px', color}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13 7.875V5.1C13 3.83988 13 3.20982 12.7548 2.72852C12.539 2.30516 12.1948 1.96095 11.7715 1.74524C11.2902 1.5 10.6601 1.5 9.4 1.5H4.6C3.33988 1.5 2.70982 1.5 2.22852 1.74524C1.80516 1.96095 1.46095 2.30516 1.24524 2.72852C1 3.20982 1 3.83988 1 5.1V12.9C1 14.1601 1 14.7902 1.24524 15.2715C1.46095 15.6948 1.80516 16.039 2.22852 16.2548C2.70982 16.5 3.33988 16.5 4.6 16.5H6.625M14.5 16.5L13.375 15.375M14.125 13.5C14.125 14.9497 12.9497 16.125 11.5 16.125C10.0503 16.125 8.875 14.9497 8.875 13.5C8.875 12.0503 10.0503 10.875 11.5 10.875C12.9497 10.875 14.125 12.0503 14.125 13.5Z"
                stroke={resolveColor(color) || '#6E6C6C'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    );
};
export default AffiliateSearch;
